import { HttpService } from "../../../Shared/Utils/HttpService";
import { ReportQuery } from "../models/ReportQuery";

export class ReportService {
  static async findTotal(pageOptions?: ReportQuery) {
    const queryParams = new URLSearchParams({
      name: pageOptions?.name || "",
      date: pageOptions?.date || "",
      interval: pageOptions?.interval || "",
      startDate: pageOptions?.startDate || "",
      endDate: pageOptions?.endDate || "",
    }).toString();
    return await HttpService.request({
      url: `/reports/find/total?${queryParams}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async findChart(pageOptions?: ReportQuery) {
    const queryParams = new URLSearchParams({
      name: pageOptions?.name || "",
      date: pageOptions?.date || "",
      interval: pageOptions?.interval || "",
      startDate: pageOptions?.startDate || "",
      endDate: pageOptions?.endDate || "",
    }).toString();

    return await HttpService.request({
      url: `/reports/find/chart?${queryParams}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async findActivity(pageOptions?: ReportQuery) {
    const queryParams = new URLSearchParams({
      name: pageOptions?.name || "",
      date: pageOptions?.date || "",
      interval: pageOptions?.interval || "",
      startDate: pageOptions?.startDate || "",
      endDate: pageOptions?.endDate || "",
    }).toString();

    return await HttpService.request({
      url: `/reports/find/activity?${queryParams}`,
      method: "GET",
      contentType: "json",
    });
  }
}
